/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createOkFromDiscriminatorValue, type ErrorResponse, type Ok } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/customer-attributes/clear
 */
export interface ClearRequestBuilder extends BaseRequestBuilder<ClearRequestBuilder> {
    /**
     * Remove all Customer Attributes from an organization
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Remove all Customer Attributes from an organization
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ClearRequestBuilderUriTemplate = "{+baseurl}/api/organizations/customer-attributes/clear";
/**
 * Metadata for all the requests in the request builder.
 */
export const ClearRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: ClearRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
